<div #container class="container">
  <div class="tables-map">
    @if (isRestuarant) {
      <img
        src="./assets/restaurant_map_without_garden_2022_06_15.png"
        alt="Mapa restauracji"
        class="map"
        draggable="false"
        />
    }
    @if (!isRestuarant) {
      <img
        src="./assets/garden_WEB%20PUSTY.png"
        alt="Mapa restauracji"
        class="map"
        draggable="false"
        />
    }
    <ng-template class="tables" appDynamic></ng-template>
    <div class="mobile-help" #mobileHelp>
      <mat-icon>pinch</mat-icon>
    </div>
  </div>
  <div class="tables-error">
    <ng-content></ng-content>
  </div>
</div>
